import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {ConclusionPagesService} from './conclusion-pages.service';
import {PagingResolverService} from '@abstract/paging-resolver.service';

/**
 * Получение данных по заключениям
 */
@Injectable()
export class FilteredConclusionResolver extends PagingResolverService {
    constructor(
        service: ConclusionPagesService,
        router: Router,
    ) {
        super(service, router);
    }
}
